import { render, staticRenderFns } from "./WikiPageHistoryWrapper.vue?vue&type=template&id=472b9dcd"
import script from "./WikiPageHistoryWrapper.vue?vue&type=script&lang=ts"
export * from "./WikiPageHistoryWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports